import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=945ce550"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('945ce550')) {
      api.createRecord('945ce550', component.options)
    } else {
      api.reload('945ce550', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=945ce550", function () {
      api.rerender('945ce550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/edit.vue"
export default component.exports